<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full flex flex-col md:flex-row justify-between mb-8 gap-4">
        <div class="flex flex-col gap-4">
            <h1 class="text-app-primary-10">Ihre Termine</h1>
            <div class="subtext font-light text-app-primary-10">Hier sehen Sie eine Übersicht all Ihrer vereinbarten Termine</div>
        </div>
        <button class="btn primary-button" routerLink="/termine/arztwahl">Neuen Termin vereinbaren</button>
    </div>

    <mat-tab-group class="mt-8 w-full" [mat-align-tabs]="'left'" [mat-stretch-tabs]="false">
        <mat-tab label="Aktuelle Termine">
            <div class="flex flex-col gap-6 pt-6">
                @for (appointment of upcomingAppointments; track appointment.id) {
                    <div class="border border-app-primary-10 bg-white p-6 rounded-button shadow-sm border flex flex-col gap-4">
                        <div class="flex flex-col lg:flex-row justify-between items-start">
                            <div class="flex gap-2">
                                <span class="text-lg font-bold text-app-primary-10">{{ appointment.from | date: 'dd.MM.yyyy' }} - </span>
                                <span class="text-app-primary-10/70">{{ appointment.from | date: 'HH:mm' }} Uhr</span>
                            </div>
                            <div class="px-3 py-1 rounded-full text-xs font-bold"
                                 [ngClass]="appointment.confirmedByPatient ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'">
                                {{ appointment.confirmedByPatient ? 'Bestätigt' : 'Ausstehend' }}
                            </div>
                        </div>

                        <div class=" pt-4 flex justify-between flex-col lg:flex-row gap-2">
                            <div class="flex flex-col gap-2">
                                <span class="text-xs font-bold text-app-primary-10/50 uppercase tracking-wider">Arzt</span>
                                <div class="flex flex-col">
                                    <span class="font-bold text-app-primary-10">{{ appointment.doctor.firstName }} {{ appointment.doctor.lastName }}</span>
                                </div>
                            </div>
                            <div class="flex gap-4">
                                <button class="btn quaternary-button" (click)="toDetails(appointment)">Zum Termin</button>
                                <button class="btn tertiary-button !text-red-600 hover:!bg-red-50" (click)="cancelAppointment(appointment)">Absagen</button>
                            </div>
                        </div>
                    </div>
                } @empty {
                    <div class="col-span-full py-20 flex flex-col">
                        <div class="text-xl font-bold text-app-primary-10 mb-2">Keine aktuellen Termine gefunden</div>
                        <div class="text-app-primary-10/50 mb-8 max-w-md">Sie haben aktuell keine vereinbarten Termine für die Zukunft. Vereinbaren Sie jetzt einen neuen Termin bei einem Arzt Ihrer Wahl.</div>
                    </div>
                }
            </div>
        </mat-tab>
        <mat-tab label="Vergangene Termine">
            <div class="flex flex-col gap-6 pt-6">
                @for (appointment of pastAppointments; track appointment.id) {
                    <div class="border border-app-primary-10 bg-white p-6 rounded-button shadow-sm border flex flex-col gap-4">
                        <div class="flex justify-between items-start flex-col lg:flex-row">
                            <div class="flex gap-2">
                                <span class="text-lg font-bold text-app-primary-10">{{ appointment.from | date: 'dd.MM.yyyy' }} - </span>
                                <span class="text-app-primary-10/70">{{ appointment.from | date: 'HH:mm' }} Uhr</span>
                            </div>
                            <div class="px-3 py-1 rounded-full text-xs font-bold bg-gray-100 text-gray-500">
                                Vergangen
                            </div>
                        </div>

                        <div class=" pt-4 flex justify-between flex-col lg:flex-row gap-2">
                            <div class="flex flex-col gap-2">
                                <span class="text-xs font-bold text-app-primary-10/50 uppercase tracking-wider">Arzt</span>
                                <div class="flex flex-col">
                                    <span class="font-bold text-app-primary-10">{{ appointment.doctor.firstName }} {{ appointment.doctor.lastName }}</span>
                                </div>
                            </div>
                            <div class="flex gap-4">
                                <button class="btn quaternary-button" (click)="toDetails(appointment)">Details</button>
                            </div>
                        </div>
                    </div>
                } @empty {
                    <div class="col-span-full py-20 flex flex-col items-center justify-center text-center">
                        <div class="text-xl font-bold text-app-primary-10 mb-2">Keine vergangenen Termine gefunden</div>
                        <p class="text-app-primary-10/50 mb-8 max-w-md">Es liegen keine Termine in der Vergangenheit vor.</p>
                    </div>
                }
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
